import { render, staticRenderFns } from "./BudgetResource.vue?vue&type=template&id=55461a65&"
import script from "./BudgetResource.vue?vue&type=script&lang=js&"
export * from "./BudgetResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports